import { useState, type ReactNode } from 'react';
import { HelpTooltip } from './HelpTooltip';
import type { ToolHelpId } from '../help/toolHelp';
import './PanelSection.css';

interface Props {
  title: string;
  help?: ToolHelpId;
  defaultOpen?: boolean;
  badge?: string;
  children: ReactNode;
}

// Collapsible titled section for the editor's right-hand panel.
export function PanelSection({
  title,
  help,
  defaultOpen = false,
  badge,
  children,
}: Props) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="panelsec">
      <button
        className="panelsec__head"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className={`panelsec__chevron ${open ? 'is-open' : ''}`}>›</span>
        <span className="panelsec__title">{title}</span>
        {help && <HelpTooltip id={help} />}
        {badge && <span className="panelsec__badge">{badge}</span>}
      </button>
      {open && <div className="panelsec__body">{children}</div>}
    </section>
  );
}
